// Carousel actualizado
<script setup>
defineOptions({ name: 'OnlineCarousel' });

import { computed, onMounted } from 'vue';
import { useGamesStore } from '../../stores/games/gamesStore';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const props = defineProps({
 isAuthenticated: {
   type: Boolean,
   required: true
 }
});

const emit = defineEmits(['show-login']);

const gamesStore = useGamesStore();
const featuredGames = computed(() => gamesStore.featuredGames);

onMounted(async () => {
 await gamesStore.loadFeaturedGames();
});

const handleGameLaunch = async (gameId) => {
 if (!props.isAuthenticated) {
   emit('show-login');
   return;
 }
 try {
   await gamesStore.launchGame(gameId);
 } catch (error) {
   console.error('❌ Error launching game:', error);
 }
};
</script>

<template>
 <div class="featured-games-carousel" v-if="featuredGames && featuredGames.length">
   <swiper
     :modules="[Navigation, Autoplay]"
     :slides-per-view="2"
     :space-between="1"
     :breakpoints="{
       '480': { slidesPerView: 3, spaceBetween: 10 },
       '768': { slidesPerView: 4, spaceBetween: 15 },
       '1024': { slidesPerView: 5, spaceBetween: 15 },
       '1280': { slidesPerView: 6, spaceBetween: 15 }
     }"
     :autoplay="{
       delay: 3000,
       disableOnInteraction: false,
       pauseOnMouseEnter: true
     }"
     :navigation="true"
     class="games-swiper"
   >
     <swiper-slide 
       v-for="game in featuredGames"
       :key="game?.id"
       class="game-slide"
     >
       <div class="game-card" @click.stop="handleGameLaunch(game?.id)">
         <div class="game-preview">
           <img 
             v-if="game?.image_url"
             :src="game.image_url"
             :alt="game?.game_name || 'Game image'"
           />
         </div>
         <div class="game-overlay">
           <span class="game-name">{{ game?.game_name || 'Loading...' }}</span>
           <div class="game-provider">{{ game?.provider?.name || 'Unknown' }}</div>
         </div>
       </div>
     </swiper-slide>
   </swiper>
 </div>
</template>
<style scoped>
@import '../../assets/styles/online/OnlineMain.css';
</style>